import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getAutoTargetReviewEndpoint } from '../../../common/endpoints';

export const postRejectAutoTargetReview = createApi(getAutoTargetReviewEndpoint, 'POST');

const RejectAutoTarget = createSlice({
  name: 'RejectAutoTarget',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postRejectAutoTargetReview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postRejectAutoTargetReview.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postRejectAutoTargetReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default RejectAutoTarget.reducer;